import { NavMenuComponent } from './nav-menu/nav-menu.component';
import * as fromShareholderEdit from './shareholder-edit';
import * as fromStock from './stock';

export const components: any[] = [
  NavMenuComponent,
  ...fromShareholderEdit.components,
  ...fromStock.components
];

export * from './nav-menu/nav-menu.component';
export * from './shareholder-edit';
